<app-order-create-layout
  #addForm
  data-testid="o2o-create-layout"
  [titleKey]="'o2o.create.title'"
  [formFields]="formFields"
  [tableSections]="tableSections"
  [summarySection]="summarySection"
  [headerActions]="headerActions"
  [loading]="loading"
  [initialData]="formData"
  [couponSuggestions]="couponSuggestions"
  [isDisableCoupon]="false"
  [autoExpandPackageChildren]="true"
  [class.o2o-pickup-mode]="
    formData?.takingDeliveryWay === O2O_TAKING_DELIVERY_WAY.pickup
  "
  (formAction)="onFormAction($event)"
  (tableAction)="onTableAction($event)"
  (couponSearch)="onCouponSearch($event)"
  (couponSelect)="onCouponSelect($event)"
  (couponUnselect)="onCouponUnselect($event)"
  (productSearch)="onProductSearchField($event)"
  (productSelect)="onProductSearchSelect($event)"
  (sectionAction)="onSectionAction($event)"
></app-order-create-layout>
<!-- Product Selection Dialog -->
<app-product-selection-dialog
  data-testid="o2o-create-product-selection-dialog"
  [visible]="showProductSelectionDialog"
  [products]="productDialogProducts"
  [loading]="productDialogLoading"
  [totalRecords]="productDialogTotalRecords"
  (visibleChange)="onProductSelectionDialogVisibleChange($event)"
  (selectionConfirm)="onProductSelectionConfirm($event)"
  (search)="onProductSearch($event)"
  (searchReset)="onProductSearchReset()"
  (pageChange)="onProductPageChange($event)"
></app-product-selection-dialog>

<p-dialog
  data-testid="o2o-create-promotion-selection-dialog"
  [visible]="showPromotionSelectionDialog"
  (visibleChange)="onPromotionDialogVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '80rem', maxWidth: '95vw' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [header]="'o2o.create.promotion_dialog.title' | translate"
>
  <app-data-table
    data-testid="o2o-create-promotion-selection-table"
    [dataSource]="promotionDialogOffers"
    [columns]="promotionDialogColumns"
    [loading]="promotionDialogLoading"
    [hasCheckColumn]="true"
    [selection]="promotionDialogSelection"
    [scrollHeight]="'auto'"
    [rows]="20"
    [totalRecords]="promotionDialogOffers.length"
    (selectionChange)="onPromotionDialogSelectionChange($event)"
  ></app-data-table>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        data-testid="o2o-create-promotion-selection-cancel-btn"
        [label]="'common.actions.cancel' | translate"
        severity="secondary"
        [outlined]="true"
        size="small"
        (onClick)="onPromotionDialogVisibleChange(false)"
      />
      <p-button
        data-testid="o2o-create-promotion-selection-confirm-btn"
        [label]="'common.actions.confirm' | translate"
        severity="info"
        size="small"
        (onClick)="onPromotionDialogConfirm()"
        [disabled]="promotionDialogSelection.length === 0"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Toast component for order creation notifications -->
<p-toast data-testid="o2o-create-coupon-validation-toast" key="coupon-validation"></p-toast>
<p-toast data-testid="o2o-create-toast"></p-toast>
